// extracted by mini-css-extract-plugin
export default {"nav_links":"NavLinks_nav_links__ZvX3L"};